import { jwtDecode } from "jwt-decode";

const FIREBASE_ISSUER_PREFIX = "https://securetoken.google.com";

export const isFirebaseToken = (token) => {
  try {
    const { iss } = jwtDecode(token);

    return typeof iss === "string" && iss.startsWith(FIREBASE_ISSUER_PREFIX);
  } catch {
    return false;
  }
};
